import {
    FETCH_DAILY_MOVEMENT,
    FETCH_DAILY_MOVEMENT_FETCHING,
    FETCH_DAILY_MOVEMENT_SUCCESS,
    FETCH_DAILY_MOVEMENT_FAIL
} from 'actions/ActionTypes.js';

const INITIAL_STATE = {
    dailyMovement: {},
    dailyMovementFetching: false,
    dailyMovementFetchFail: false
};

// ======= Fetching Handlers =======
const fetchDailyMovementFetching = (state, action) => {
    return {
        dailyMovement: {
            ...state.dailyMovement
        },
        dailyMovementFetching: true,
        dailyMovementFetchFail: false
    };
};

const fetchDailyMovementSuccess = (state, action) => {
    return {
        dailyMovement: {
            ...state.dailyMovement,
            [action.displayName]: {
                ...state.dailyMovement[action.displayName],
                [action.calendarDate]: action.dailyMovement
            }
        },
        dailyMovementFetching: false,
        dailyMovementFetchFail: false
    };
};

const fetchDailyMovementFail = (state, action) => {
    return {
        dailyMovement: {
            ...state.dailyMovement
        },
        dailyMovementFetching: false,
        dailyMovementFetchFail: true
    };
};

// ======= Handler Assignments =======
const handlers = {
    [FETCH_DAILY_MOVEMENT_FETCHING]: fetchDailyMovementFetching,
    [FETCH_DAILY_MOVEMENT_SUCCESS]: fetchDailyMovementSuccess,
    [FETCH_DAILY_MOVEMENT_FAIL]: fetchDailyMovementFail
};

// ======= Default Action =======
export default function dailyMovement(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// ======= Actions =======
export function fetchDailyMovement(displayName, calendarDate, evictCache) {
    return {
        type: FETCH_DAILY_MOVEMENT,
        displayName: displayName,
        calendarDate: calendarDate,
        meta: {
            cacheTime: evictCache ? null : 120000
        }
    };
}

// ======= Selectors =======
export const getDailyMovement = (state, displayName, calendarDate) => {
    return state.dailyMovement.dailyMovement[displayName]
        ? state.dailyMovement.dailyMovement[displayName][calendarDate]
        : null;
};

export const isDailyMovementFetching = (state) => {
    return state.dailyMovement.dailyMovementFetching;
};

export const didDailyMovementFetchFail = (state) => {
    return state.dailyMovement.dailyMovementFetchFail;
};
